import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, QueryParameterState, addQueryParam, changeQueryParams } from 'src/api';
import { RouterState } from 'connected-react-router';
import { Icon } from '../../Images';

import './ConfigurationSwitchView.scss';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationSwitchView.messages';
import { userIsInternal, userIsSalesRep } from '../../Admin/utils';
import { Link } from 'react-router-dom';
import { ModalContainer } from 'src/app/Container/Modal/Modal';
import ConfigurationNewFolder from './ConfigurationNewFolder';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import NewButtons from './NewButtons';

export interface ConfigurationSwitchViewState {
}

export interface ConfigurationSwitchViewProps {
  dispatch: any;
  configurations: GlobalPrivateState['configurations'];
  location: RouterState['location'];
  params: QueryParameterState['params'];
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
}

export class ConfigurationSwitchViewPartial extends React.Component<ConfigurationSwitchViewProps, ConfigurationSwitchViewState> {

  constructor(props: ConfigurationSwitchViewProps) {
    super(props);
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  public render() {
    const tab: any = this.props.params.tab || 'mine';
    const isInternalUser = userIsInternal(this.props.user.result) || userIsSalesRep(this.props.user.result);

    return (
      <div className={[
        "partial-configuration-switch-view", 
        this.props.configurations.updating ? "updating" : ""
      ].join(' ')}>
        <ul className={`list list-tabswitch list-unstyled float-left`}>
          <li className="d-inline-block">
            <button
              disabled={tab === 'mine'}
              onClick={(ev) => this.handleTabClick(ev, 'mine')}
              className={`btn btn-link p-0 ${tab === 'mine' ? 'active' : ''}`}
            >
              <FormattedMessage {...MESSAGES.configurationSwitchViewMine} />
            </button>
          </li>
          {isInternalUser && (
            <li className="d-inline-block">
              <button
                disabled={tab === 'others'}
                onClick={(ev) => this.handleTabClick(ev, 'others')}
                className={`btn btn-link p-0 ${tab === 'others' ? 'active' : ''}`}
              >
                <FormattedMessage {...MESSAGES.configurationSwitchViewOthers} />
              </button>
            </li>
          )}
          <li className="d-inline-block">
            <button
              disabled={tab === 'archived'}
              onClick={(ev) => this.handleTabClick(ev, 'archived')}
              className={`btn btn-link p-0 ${tab === 'archived' ? 'active' : ''}`}
            >
              <FormattedMessage {...MESSAGES.configurationSwitchViewArchived} />
            </button>
          </li>
        </ul>

        <NewButtons />
      </div>
    );
  }

  private handleTabClick(event: React.MouseEvent, type: any) {
    const { tab } = this.props.params;
    if (tab !== type) {
      // this.props.dispatch(addQueryParam('tab', type));
      this.props.dispatch(changeQueryParams({
        ...this.props.params,
        tab: type
      }));
    }
  }
}

export const ConfigurationSwitchView = connect((state: GlobalPrivateState) => ({
  configurations: state.configurations,
  location: state.router.location,
  params: state.queryState.params,
  user: state.user,
  userData: state.userData,
}))(ConfigurationSwitchViewPartial);

export default ConfigurationSwitchView;
